import React, { useState, useEffect, useMemo } from "react";
import { Nav, Form, Tab, Modal } from "react-bootstrap";
import Header from "../../../Components/Header";
import Loader from "../../../Components/Common/Loader";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { Constants } from "../../../CommonMethhods/Constants";
import { useDebounce } from "../../../Components/useDebounce";
import { Baseurl, Frenchisee } from "../../../Configuration/Frenchisee_URL";
import FrenchiseeOnboardingAll from "../FrenchiseeOnboardingAll";
import FrenchiseeOnboardingApproved from "../FrenchiseeOnboardingApproved";
import FrenchiseeOnboardingRejected from "../FrenchiseeOnboardingRejected";
import FrenchiseeOnboardingActive from "../FrenchiseeOnboardingActive";
import FrenchiseeOnboardingDraft from "../FrenchiseeOnboardingDraft";
import FrenchiseeOnboardingUnderReview from "../FrenchiseeOnbaordingUnderReview";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import axiosInstance, { axiosFormDataInstance } from "../../../CommonMethhods/axiosInstance";

function FranchiseeOnboardingDashboard() {
  const storeToken = localStorage.getItem("ssoToken");
  const [linecard, setLinecard] = useState("block-active col-division-5");
  const [loader, setLoader] = useState(false);
  const [tabStatus, setTabStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [dayWiseDate, setDayWiseDate] = useState("this-month");
  const [customDate, setCustomDate] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [frenchiseeOnboardingData, setFrenchiseeOnboardingData] = useState([]);
  localStorage.setItem("statusOfClient", tabStatus);
  const [name, setName] = useState("");
  const [userType, setUserType] = useState(sessionStorage.getItem("userType") || "AP");

  useEffect(() => {
    sessionStorage.setItem("userType", userType);
  }, [userType]);
 

  if (storeToken == null) {
    window.location.replace("/");
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // search bar code start
  const debouncedValue = useDebounce(name, 1000);
  useEffect(() => {
    if (debouncedValue) {
      handleSearchName(debouncedValue);
    }
  }, [debouncedValue]);

  const handleSearchName = () => {
    if (debouncedValue) {
      onboardingApiData(page, tabStatus, 10, dayWiseDate, debouncedValue);
      setLoader(false);
    }
    setScrollLoader(false);
  };

  useEffect(() => {
    if (localStorage.getItem("activeTab")) {
      setTabStatus(localStorage.getItem("activeTab"));
    } else {
      onboardingApiData(page, tabStatus, 10, dayWiseDate, name == "");
    }
    return () => {
      localStorage.removeItem("activeTab");
    };
  }, [page, tabStatus, dayWiseDate, name == "", userType]);

  if (storeToken == null) {
    window.location.replace("/");
  }
  function handleGridView(e) {
    if (linecard === "") setLinecard("block-active col-division-5");
  }

  function handleListView() {
    if (linecard === "block-active col-division-5") setLinecard("");
  }

  const onboardingApiData = async (pageNo = 1, tab, sizePage = 10, dayWise) => {
    setLoader(true);

    try {
      const getOnboardingDetails = await axiosInstance.get(
        `${Frenchisee.GET_FRENCHISEE_DETAILS}?status=${tab}&page=${pageNo}&limit=${sizePage}&range=${dayWise}&to=${toDate}&from=${fromDate}&search=${name}&userType=${userType}`,
      );
      const res = decryptData(getOnboardingDetails?.data);
      let respStore = JSON.parse(res);
      if (respStore?.status === 0) {
        setTotalCount(respStore.data.info.count);
        if (pageNo > 1) {
          setFrenchiseeOnboardingData((prev) => {
            return [...prev, ...respStore?.data.info.franchisees];
          });
        } else {
          setFrenchiseeOnboardingData(respStore?.data.info.franchisees);
        }
      } else {
        setFrenchiseeOnboardingData([]);
      }
    } catch (error) {
      console.log(error, "err");
      toast.error("Something went wrong");
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  // for pagination start
  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(totalCount <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  // for pagination end
  function handleTabStatus(status) {
    setTabStatus(status);
    setPage(1);
    setName("");
    localStorage.setItem("statusOfClient", tabStatus);
  }
  const handleOnChange = (e) => {
    setPage(1);
    // setTabStatus("all");
    if (e.target.value != "Custom Range") {
      setDayWiseDate(e.target.value);
      setName("");
    } else {
      setDayWiseDate("");
      setName("");
      setCustomDate(true);
    }
  };
  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            onboardingApiData(page, tabStatus, 10, dayWiseDate);
            setCustomDate(false);
            setFromDate("");
            setToDate("");
          }}
        >
          Button
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Button
        </button>
      );
    }
  }

  const downloadFile = async (url) => {
    const response = await axiosFormDataInstance.get(url);
    const headers = response.headers;
    if (headers["content-type"] !== "text/csv") {
      toast.error("No Data Found");
      return;
    }
    const binary = [];
    binary.push(response.data);
    const href = window.URL.createObjectURL(
      new Blob(binary, { type: "text/csv" })
    );
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "lead.csv");
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(href);
  };

  return (
    <>
      <Header portal={"TELECALLER"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending">
        <div className="tab-content" id="myTabContent">
          <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
            {/* page tabs */}
            <div>
              <Nav variant="nav tabs page-tabs partner-backoffice-nav">
                <li className="nav-item" onClick={() => handleTabStatus("all")}>
                  <Nav.Link eventKey="all">All</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("approved")}
                >
                  <Nav.Link eventKey="approved">Approved</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("rejected")}
                >
                  <Nav.Link eventKey="rejected">Rejected</Nav.Link>
                </li>

                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("active")}
                >
                  <Nav.Link eventKey="active">Active</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("draft")}
                >
                  <Nav.Link eventKey="draft">Draft</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("under-review")}
                >
                  <Nav.Link eventKey="under-review">Under Review</Nav.Link>
                </li>
              </Nav>
            </div>

            <div className="onboarding-secondary-tab-list">
              <div className="search-box">
                <div className="form-group">
                  <div className="for-position oms-search">
                    <input
                      type="text"
                      className="input-st"
                      placeholder="Search here..."
                      autoComplete="off"
                      id="trad-map"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setPage(1);
                      }}
                      onInput={(e) => {
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;

                        let input = e.target.value.toUpperCase();
                        input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                        input = input.replace(/\s{2,}/g, " ");
                        input = input.replace(/^\s+/, "");

                        if (input.length > 100) input = input.slice(0, 100);
                        e.target.value = input;
                        e.target.setSelectionRange(start, end);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="menu-rank-wrapper partner-menu">
                <div className="toggle-wrapper">
                  <div
                    className="capsule"
                    style={{left: userType === "AP" ? "2px" : "55px"}}
                  />

                  <div
                    className="capsule-content"
                    onClick={() => setUserType("AP")}
                    style={{color: userType === "AP" ? "#fff" : "#555"}}
                  >
                    AP
                  </div>

                  <div
                    className="capsule-content"
                    onClick={() => setUserType("RP")}

                    style={{color: userType === "RP" ? "#fff" : "#555"}}
                  >
                    RP
                  </div>
                </div>
                <div
                  onClick={() =>
                    downloadFile(
                      `${Baseurl}/franchisees/csv?status=${tabStatus}&range=${dayWiseDate}&userType=${userType}`,
                    )
                  }
                  className={
                    frenchiseeOnboardingData &&
                    frenchiseeOnboardingData.length > 0
                      ? ""
                      : "disabled-link"
                  }
                >
                  <span className="icon-download"></span>
                  {/* <img src={download} alt="download" /> */}
                </div>
                <div className="card-right card-tabs">
                  <div className="dropdown-filter">
                    <Form.Select
                      size="lg"
                      aria-label="Default select example"
                      onChange={handleOnChange}
                    >
                      <option value="this-month">This Month</option>
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="this-week">This Week</option>
                      <option value="last-week">Last Week</option>
                      <option value="last-month">Last Month</option>
                      <option value="till-date">Till Date</option>
                      <option value="Custom Range">Custom Range</option>
                    </Form.Select>
                  </div>
                </div>
                <div className="menu-wrapper">
                  <span
                    className="icon-block-menu"
                    onClick={handleGridView}
                  ></span>
                  <span
                    className="icon-horizontal-menu"
                    onClick={handleListView}
                  ></span>
                </div>
              </div>
            </div>
            <div className="for-grid-section partner-backoffice-onboarding">
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <Tab.Content>
                  <FrenchiseeOnboardingAll
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                  <FrenchiseeOnboardingApproved
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                  <FrenchiseeOnboardingRejected
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                  <FrenchiseeOnboardingActive
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                  <FrenchiseeOnboardingDraft
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                  <FrenchiseeOnboardingUnderReview
                    frenchiseeOnboardingData={frenchiseeOnboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                  />
                </Tab.Content>
              )}
            </div>
          </Tab.Container>
        </div>
        {customDate && customDate ? (
          <Modal
            show={customDate}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="setting-model partner-modal-rejection"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                <h2 className="model-title">Custom Date</h2>
              </Modal.Title>
              <button type="button" className="btn-close" aria-label="Close">
                <span
                  className="icon-close"
                  onClick={() => setCustomDate(false)}
                ></span>
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="custom-modal-wrapper row">
                <div className="col-md-6 col-12">
                  <label className="form-label">{Constants.From_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <label className="form-label">{Constants.To_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <SubmitButton />
            </Modal.Footer>
          </Modal>
        ) : null}
      </main>
    </>
  );
}

export default FranchiseeOnboardingDashboard;
